@if (quoteRequestForm !== undefined && selectedStateBond() !== null &&
sectionHasQuestions('project_information', selectedStateBond())) {
<form [formGroup]="quoteRequestForm" class="cipx-form-section">
  <fieldset>
    <legend class="cipx-form-section-title">Project Information</legend>

    <cipx-quote-request-intake-form-question-set
      [quoteRequestForm]="quoteRequestForm"
      [stateBond]="selectedStateBond()"
      layoutName="project_information"></cipx-quote-request-intake-form-question-set>
  </fieldset>
</form>
}

@if (quoteRequestForm !== undefined && selectedStateBond() !== null &&
sectionHasQuestions('screening', selectedStateBond())) {
<form [formGroup]="quoteRequestForm" class="cipx-form-section">
  <fieldset>
    <legend class="cipx-form-section-title">Quick Questions</legend>

    <cipx-quote-request-intake-form-question-set
      [quoteRequestForm]="quoteRequestForm"
      [stateBond]="selectedStateBond()"
      layoutName="screening"></cipx-quote-request-intake-form-question-set>
  </fieldset>
</form>
}
